import axios from 'axios';
import {checkErrors} from './errors';

export const LOADUSERS_REQUESTED = 'users/LOADUSERS_REQUESTED';
export const LOADUSERS_FINISHED = 'users/LOADUSERS_FINISHED';
export const SETUSERS = 'users/SETUSERS';

export const ADDUSER_REQUESTED = 'users/ADDUSER_REQUESTED';
export const ADDUSER_FINISHED = 'users/ADDUSER_FINISHED';

export const EDITUSER_REQUESTED = 'users/EDITUSER_REQUESTED';
export const EDITUSER_FINISHED = 'users/EDITUSER_FINISHED';

export const REMOVEUSER_REQUESTED = 'users/REMOVEUSER_REQUESTED';
export const REMOVEUSER = 'users/REMOVEUSER';
export const REMOVEUSER_FINISHED = 'users/REMOVEUSER_FINISHED';

export const LOADUSER_REQUESTED = 'users/LOADUSER_REQUESTED';
export const LOADUSER_FINISHED = 'users/LOADUSER_FINISHED';

const initialState = {
  users: [],
  total: 0,
  limit: 1000,
  skip: 0,
  isLoadingUsers: false,
  isAddingUser: false,
  isEditingUser: false,
  isRemovingUser: false,
  isLoadingUser: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
  case LOADUSERS_REQUESTED:
    return {
      ...state,
      isLoadingUsers: true
    };

  case LOADUSERS_FINISHED:
    return {
      ...state,
      isLoadingUsers: false
    };

  case SETUSERS:
    
    return {
      ...state,
      users: action.users
    };

  case ADDUSER_REQUESTED:
    return {
      ...state,
      isAddingUser: true
    };

  case ADDUSER_FINISHED:
    return {
      ...state,
      isAddingUser: false
    };
  
  case EDITUSER_REQUESTED:
    return {
      ...state,
      isEditingUser: true
    };

  case EDITUSER_FINISHED:
    return {
      ...state,
      isEditingUser: false
    };

  case REMOVEUSER:
    return {
      ...state,
      users: action.users
    };

  case REMOVEUSER_REQUESTED:
    return {
      ...state,
      isRemovingUser: true,
    };

  case REMOVEUSER_FINISHED:
    return {
      ...state,
      isRemovingUser: false
    };
  
  case LOADUSER_REQUESTED:
    return {
      ...state,
      isLoadingUser: true
    };

  case LOADUSER_FINISHED:
    return {
      ...state,
      isLoadingUser: false
    };

  default:
    return state;
  }
};


export const loadUsers = () => {
  return (dispatch, getState) => {

    dispatch({
      type: LOADUSERS_REQUESTED
    });

    axios.get(`${window.endpoint}/users`, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {

      
      dispatch({
        type: SETUSERS,
        users: response.data.users
      });
      
      dispatch({
        type: LOADUSERS_FINISHED
      });
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};

export const addUser = (data, cb) => {
  return (dispatch, getState) => {

    dispatch({
      type: ADDUSER_REQUESTED
    });

    axios.post(`${window.endpoint}/users`, data, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {
      
      dispatch({
        type: ADDUSER_FINISHED
      });

      if (cb instanceof Function) { cb(response); }
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};

export const editUser = (id, data, cb) => {
  return (dispatch, getState) => {
    

    dispatch({
      type: EDITUSER_REQUESTED
    });

    axios.post(`${window.endpoint}/users/${id}`, data, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {
      
      dispatch({
        type: EDITUSER_FINISHED
      });

      if (cb instanceof Function) { cb(response); }
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};

export const removeUser = (id, cb) => {
  return (dispatch, getState) => {

    const usersState = getState().users;

    dispatch({
      type: REMOVEUSER_FINISHED
    });

    axios.delete(`${window.endpoint}/users/${id}`, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {

      dispatch({
        type: REMOVEUSER,
        users: usersState.users.filter((user) => user.user_id !== id)
      });
      
      dispatch({
        type: REMOVEUSER_FINISHED
      });

      if (cb instanceof Function) { cb(response); }
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};

export const loadUser = (user_id, cb) => {
  return (dispatch, getState) => {

    dispatch({
      type: LOADUSER_REQUESTED
    });

    axios.get(`${window.endpoint}/users/${user_id}`, { headers: { Authorization: localStorage.getItem(window.token) } }).then(response => {
      
      dispatch({
        type: LOADUSER_FINISHED
      });

      if (cb instanceof Function) { cb(response); }
      
    }).catch((error) => {
      checkErrors(error);
    });
    
  };
};


// WEBPACK FOOTER //
// ./src/reducers/users.js